import gql from 'graphql-tag';

export class SubscriptionMutations {
  static updateSubscription = gql`
    mutation UpdateSubscription(
      $newDealroomSeats: Float
      $newContractSeats: Float
      $newSuiteSeats: Float
      $subscriptionId: String!
    ) {
      updateSubscription(
        newDealroomSeats: $newDealroomSeats
        newContractSeats: $newContractSeats
        newSuiteSeats: $newSuiteSeats
        subscriptionId: $subscriptionId
      )
    }
  `;
}
